import { useCallback } from "react";
import { useTranslation } from "react-i18next";
import queryKeys from "@configs/react-query/query-key";
import { useMutationData } from "@hooks/useMutationData";
import { handleLicensePolicyMutationError } from "@utils/error";
import { showErrorToast } from "@configs/react-toastify/snackbar";

const useImportFile = () => {
  const { t } = useTranslation();

  const { mutate, isLoading, error } = useMutationData(
    queryKeys.licensePolicyImport,
    {
      method: "POST",
      headers: {
        "Content-Type": "multipart/form-data",
      },
    },
  );

  const importFile = useCallback(
    async (file) => {
      try {
        if (!file) {
          throw new Error(t("license-policy.no-file-selected"));
        }
        if (!file.name.endsWith(".xlsx") && !file.name.endsWith(".xls")) {
          throw new Error(t("license-policy.invalid-file-format"));
        }

        const formData = new FormData();
        formData.append("file", file);

        return await new Promise((resolve, reject) => {
          mutate(formData, {
            onSuccess: resolve,
            onError: reject,
          });
        });
      } catch (err) {
        if (err?.response) {
          handleLicensePolicyMutationError(err, t, showErrorToast, t("toast.invalid-file"));
        } else {
          showErrorToast(t("common.error"), err?.message || t("toast.invalid-file"));
        }
        throw err;
      }
    },
    [t, mutate],
  );

  return { importFile, isLoading, error };
};

export default useImportFile;
